interface ErrorAlertProps {
  error: string | null
  onClose?: () => void
  className?: string
}

export default function ErrorAlert({ error, onClose, className = '' }: ErrorAlertProps) {
  if (!error) return null

  return (
    <div className={`bg-red-50 border border-red-200 rounded-lg p-4 mb-4 ${className}`}>
      <div className="flex items-start justify-between">
        <div className="flex">
          <div className="text-red-500 mr-2">⚠️</div>
          <div>
            <h4 className="text-red-800 font-medium mb-1">エラーが発生しました</h4>
            <p className="text-red-600 text-sm">{error}</p>
          </div>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="text-red-400 hover:text-red-600 ml-4"
            aria-label="エラーを閉じる"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  )
}